<template>
    <div class="margin">
        <Tables ref="tableGrid"
            :columns="headTable"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad"
                >
                    <tr v-for="obj in dataSpent" :key="obj.id">
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                        <TableColumn :IsText="true" :status="obj.status" :value="teste" />
                    </tr>
                    <tr>
                        <td colspan="5"></td>
                        <td class="text-center total-table">TOTAL:</td>
                    </tr>
        </Tables>
    </div>
</template>

<script>
import tableCreditUpdate from './tableCreditUpdate'
export default tableCreditUpdate
</script>

<style>
.total-table{
    border: 1px solid rgb(219, 219, 219);
    color: #025e33;
    font-weight: bold;
}
.margin{
    margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tableCreditUpdate/tableCreditUpdate.vue